import React from 'react';
import styled from 'styled-components';
import Text, { TypeVariant } from 'shared/Typography';

interface Props {
  name: string;
  quote: string;
}

const Item = styled.div`
  width: 100%;
  padding: 0 15px;
`;

const Quote = styled.div`
  padding-bottom: 36px;
`;

const TestimonialSectionItem: React.FC<Props> = ({ name, quote }) => (
  <Item key={name}>
    <Quote>
      <Text
        variant={TypeVariant.subtitle02}
        as="p"
        color="var(--color-white)"
        tablet={TypeVariant.bodyLarge01}
        textAlign="center"
      >
        {`"${quote}"`}
      </Text>
    </Quote>
    <Text
      variant={TypeVariant.body01Bold}
      as="p"
      color="var(--color-secondary-100)"
      textAlign="center"
    >
      {name}
    </Text>
  </Item>
);

export default TestimonialSectionItem;
